(function () {
    /* globals $, angular */
    "use strict";

    angular.module("dashboardApp").config(Config);

    Config.$inject = ['$routeProvider'];

    function Config($routeProvider) {


        $routeProvider.when('/start', {
            templateUrl: 'ui/build/html/core/start/start.view.html',
            controller: "startController",
            controllerAs: "vm"
        });



        $routeProvider.when('/login', {
            templateUrl: 'ui/build/html/core/login/login.view.html',
            controller: "loginController",
            controllerAs: "vm"
        });



        $routeProvider.when('/logout', {
            templateUrl: 'ui/build/html/core/logout/logout.view.html',
            controller: "logoutController",
            controllerAs: "vm"
        });



        $routeProvider.when('/apps', {
            templateUrl: 'ui/build/html/core/apps/apps.view.html',
            controller: "appsController",
            controllerAs: "vm"
        });



        $routeProvider.when('/forgot-password', {
            templateUrl: 'ui/build/html/core/forgot-password/forgot-password.view.html',
            controller: "forgotPasswordController",
            controllerAs: "vm"
        });



        $routeProvider.when('/account', {
            templateUrl: 'ui/build/html/core/account/account.view.html',
            controller: "accountController",
            controllerAs: "vm"
        });



        $routeProvider.when('/usage-tracker', {
            templateUrl: 'ui/build/html/core/usage-tracker/usage-tracker.view.html',
            controller: "usageTrackerController",
            controllerAs: "vm"
        });



        $routeProvider.when('/environment', {
            templateUrl: 'ui/build/html/core/environment/environment.view.html',
            controller: "environmentController",
            controllerAs: "vm"
        });


        $routeProvider.when('/info', {
            templateUrl: 'ui/build/html/core/info/info.view.html'
        });




        $routeProvider.otherwise('/start');


    }
})();
